import { QueryTuple, useLazyQuery } from '@apollo/client';
import { GET_COST_CODES } from '@bechtel/client-gql';
import { CostCodeList } from '@bechtel/types';

export function useCostCodesQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ costCodeList: CostCodeList }, Record<string, any>> {
  const response = useLazyQuery<{ costCodeList: CostCodeList }>(
    GET_COST_CODES,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
